/** Single source for the backend API base URL. */
export function getUrls(): { backendUrl: string } {
  const env = (import.meta as { env?: Record<string, string | undefined> }).env || {};
  let backendUrl = env.VITE_BASE_URL_API || 'http://localhost:3333/api/';
  if (!backendUrl.endsWith('/')) {
    backendUrl += '/';
  }
  return { backendUrl };
}

/**
 * The sm-dashboard frontend (dev → its staging, prod → int.chabadisrael.co.il), for the links that
 * open one of its own pages — the כרטיס ביקור, for one. Unset means those links are hidden: the
 * browser never talks to the dashboard's API, only to its pages (DASHBOARD-USERS.md §3).
 */
export function getSmDashboardUrl(): string | null {
  const env = (import.meta as { env?: Record<string, string | undefined> }).env || {};
  const url = env.VITE_SM_DASHBOARD_URL?.trim();
  return url ? url.replace(/\/+$/, '') : null;
}
